var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18911_23109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4781 7.06733L29.8746 2.51241C27.8371 0.50644 24.5284 0.492894 22.4863 2.48983L17.3782 7.47259C15.3328 9.4684 15.3237 12.7195 17.3557 14.7243L20.2749 11.9203C19.9791 11.0273 20.3437 10.0046 21.0662 9.29681L24.3162 6.12812C25.3457 5.12909 26.9972 5.13361 28.0132 6.13941L30.7777 8.87124C31.7937 9.87704 31.7892 11.4969 30.7664 12.4982L27.5165 15.6692C26.829 16.3397 25.7001 16.7077 24.8241 16.4718L21.9648 19.2781C24.0001 21.2886 27.3065 21.2976 29.3531 19.3007L34.4555 14.3225C36.5066 12.3233 36.5134 9.07556 34.4781 7.06733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7762 25.3028C16.0189 26.1754 15.6305 27.3042 14.9273 27.9906L11.8918 30.9561C10.851 31.972 9.16673 31.9664 8.13044 30.9425L5.31057 28.1644C4.27654 27.1417 4.28331 25.4789 5.32412 24.4674L8.36186 21.5019C9.10238 20.7829 10.1658 20.4171 11.0937 20.7242L14.0219 17.823C11.9493 15.7786 8.57634 15.7685 6.49473 17.8004L1.56955 22.6093C-0.514309 24.6447 -0.524469 27.9533 1.54698 30.0022L6.23623 34.6384C8.30654 36.6805 11.6773 36.6906 13.7634 34.6587L18.6886 29.8498C20.7702 27.8122 20.7792 24.5058 18.7112 22.4592L15.7762 25.3028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5753 23.9798C13.2651 24.6763 14.3939 24.6831 15.0972 23.9889L23.5128 15.6173C24.2138 14.9208 24.2183 13.7942 23.5218 13.0954C22.8298 12.4012 21.7032 12.3967 21.0045 13.0887L12.5866 21.458C11.8867 22.1522 11.8822 23.2788 12.5753 23.9798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18911_23109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainSingle);
export default __webpack_public_path__ + "static/media/chain-single.519d980ba5d3b3a4766f5c03d8a13ff6.svg";
export { ForwardRef as ReactComponent };